import { createFileRoute } from "@tanstack/react-router"
import { validateInstructorSectionSearch } from "@/utils/instructorSectionSearch"
import { queryClient } from "@/queryClient"
import { getCourseOptions, getProjectOptions } from "@/client/@tanstack/react-query.gen"
import InstructorProject from "@/routes/-pages/InstructorProject"
import { runBackendModePrefetch } from "@/utils/routePrefetch"

export const Route = createFileRoute("/instructor/course/$courseId/project/$projectId/")({
  validateSearch: validateInstructorSectionSearch,
  loader: ({ params }) => {
    return runBackendModePrefetch(() =>
      Promise.all([
        queryClient.prefetchQuery(getCourseOptions({ path: { course_id: params.courseId } })),
        queryClient.prefetchQuery(getProjectOptions({ path: { project_id: params.projectId } })),
      ]),
    )
  },
  component: InstructorProject,
})
